import { toast } from "sonner";

export const copyText = (v, label = "Copied") => navigator.clipboard?.writeText(v).then(() => toast.success(label), () => toast.error("Couldn't copy. Select the text and copy it manually."));

export const fmt = (iso) => (iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "");

export const DNS_LABEL = {
  not_configured: ["DNS not configured", "bg-slate-100 text-slate-700"],
  partial: ["DNS partially configured", "bg-amber-100 text-amber-800"],
  propagating: ["DNS propagation in progress", "bg-sky-100 text-sky-800"],
  incorrect: ["DNS configuration incorrect", "bg-red-100 text-red-800"],
  verified: ["DNS verified successfully", "bg-emerald-100 text-emerald-800"],
  waiting_hosting: ["Waiting for Altiora's domain server", "bg-amber-100 text-amber-800"],
};

export const SSL_LABEL = {
  pending: ["Pending", "bg-slate-100 text-slate-700", "Waiting for your DNS to be verified."],
  processing: ["Processing", "bg-sky-100 text-sky-800", "Your secure certificate is being issued. This usually takes a few minutes."],
  active: ["Active", "bg-emerald-100 text-emerald-800", "Your secure certificate (HTTPS padlock) is active."],
  failed: ["Failed", "bg-red-100 text-red-800", "The certificate couldn't be issued. Check your DNS, then click Retry SSL."],
  unavailable: ["Not available yet", "bg-amber-100 text-amber-800", "Altiora's hosting can't issue certificates for your own domain yet. We won't show it as working until it really is."],
  provider: ["http:// only", "bg-amber-100 text-amber-800", "Your domain forwards, but your provider doesn't offer secure https:// forwarding for it. Visitors typing your domain still reach your website, which itself is secure."],
};

export const Badge = ({ map, value, testid }) => {
  const [txt, cls] = map[value] || ["Not checked yet", "bg-slate-100 text-slate-600"];
  return <span className={`text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${cls}`} data-testid={testid}>{txt}</span>;
};
